export const useStudentClassroomDataStore = (studentId: string) => {
  const uid = useCurrentUID();

  if (!uid) {
    throw new Error("No current user");
  }

  return useStudentClassroomData(uid, studentId)();
};
